import { useEffect, useState } from 'react';

export function useDebounce(value: string, delay: number, callback?: () => void) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      callback && debouncedValue !== value && callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, callback, debouncedValue]);

  return debouncedValue;
}
